// List of server endpoints requiring authentication;
export const PROTECTED_API_ENDPOINTS = [
  "/authenticate"
];
